import { motion } from "framer-motion";
import { KeyRound, DoorOpen, Copy, Siren } from "lucide-react";

const services = [
    {
        id: "car-keys",
        icon: KeyRound,
        title: "برمجة مفاتيح السيارات",
        desc: "برمجة وتشفير المفاتيح الذكية والريموتات لجميع الماركات — تويوتا، هيونداي، مرسيدس، فورد وغيرها. مفتاح جديد كامل حتى لو ضاع آخر مفتاح عندك.",
        span: "md:col-span-2",
    },
    {
        id: "door-opening",
        icon: DoorOpen,
        title: "فتح الشقق والأبواب المقفلة",
        desc: "انقلع الباب عليك؟ نفتح أقفال الشقق والفلل والمحلات بأدوات احترافية بدون خدش أو كسر.",
        span: "",
    },
    {
        id: "key-cutting",
        icon: Copy,
        title: "نسخ وقص المفاتيح",
        desc: "نسخ فوري لمفاتيح المنازل والسيارات بقصّ دقيق يطابق الأصل تماماً.",
        span: "",
    },
    {
        id: "emergency",
        icon: Siren,
        title: "طوارئ 24 ساعة",
        desc: "منتصف الليل أو وقت الفجر — فريقنا جاهز ويتحرك لموقعك فور اتصالك في أي حي بجدة.",
        span: "md:col-span-2",
    },
];

const Services = () => (
    <section id="services" data-testid="services-section" className="relative py-24 sm:py-32">
        <div className="mx-auto max-w-6xl px-4 sm:px-6">
            <motion.div
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7 }}
                className="mb-14"
            >
                <p className="mb-3 text-xs font-bold uppercase tracking-[0.25em] text-amber-500">
                    خدماتنا
                </p>
                <h2 className="font-display text-3xl font-black text-white sm:text-4xl">
                    كل ما يخص المفاتيح والأقفال
                </h2>
                <p className="mt-4 max-w-xl text-base text-gray-400 sm:text-lg">
                    خدمة واحدة تغطي كل طوارئ المفاتيح — بسيارتك أو ببيتك، نهاراً أو ليلاً.
                </p>
            </motion.div>

            <div className="grid gap-5 md:grid-cols-3">
                {services.map((s, i) => (
                    <motion.article
                        key={s.id}
                        initial={{ opacity: 0, y: 28 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-60px" }}
                        transition={{ duration: 0.6, delay: i * 0.1 }}
                        data-testid={`service-card-${s.id}`}
                        className={`service-card group rounded-3xl border border-[#232F45] bg-[#151C2A] p-7 sm:p-8 ${s.span}`}
                    >
                        <span className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-500/12 text-amber-400 transition-transform duration-300 group-hover:scale-110">
                            <s.icon size={26} strokeWidth={2.2} />
                        </span>
                        <h3 className="font-display mb-3 text-xl font-extrabold text-white sm:text-2xl">
                            {s.title}
                        </h3>
                        <p className="text-sm leading-relaxed text-gray-400 sm:text-base">
                            {s.desc}
                        </p>
                    </motion.article>
                ))}
            </div>
        </div>
    </section>
);

export default Services;
